<template>
  <div class="about">
    <h2 class="title">about.</h2>
    <div class="about-content">
      <img class="hero wow fadeIn animated" src="../assets/hero.jpg" alt="Cindy Chea" />
      <p class="wow slideInUp animated">Hi, I’m Cindy, a full stack web developer, former health care professional, and overall a compassionate and open-minded thinker. My curiosity drives me to learn more and do more, from researching the optimal conditions for growing an orchid, to climbing my first outdoor multi-pitch route in Peru, to learning about the most efficient ways to build attractive websites with clean code. I am motivated by the thrill of problem solving, the flow and exchange of ideas in collaborative environments, and the ability to contribute a thoughtful solution to the problem at hand, no matter how big or small.</p>
    </div>
    <div class="contact-icons wow slideInUp animated">
      <a href="https://www.linkedin.com/in/cindy-chea/"><fa :icon="['fab', 'linkedin']" /></a>
      <a href="https://github.com/cindychea"><fa :icon="['fab', 'github']" /></a>
      <a href="mailto:cindy_chea@hotmail.com"><fa icon="envelope" /></a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'about',
  components: {
    HelloWorld
  }
}
</script>

<style lang="scss">
.about {
  min-height: 100vh;
  width: 100%;

  .about-content {
    border-radius: 20px;
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    .hero {
      max-width: 250px;
      border-radius: 50%;
      border: 1px solid #825B6D;
      margin: 0 auto 2em;
    }

    p {
      max-width: 800px;
      font-size: 1.2em;
      font-family: 'Raleway', sans-serif;
      // animation: 3s slide-up;
      margin: 0;
    }
  }
  .contact-icons {
    margin: 2em 0;
    a {
      color: #242B38;
      text-decoration: none;
      padding: 15px;
      svg {
      font-size: 50px;
      }
    }
    a:hover {
      color: #e93646;
    }
  }
}
</style>